import {Base} from "@/api/Base"

export class PlanEdit extends Base {
    path = "plan/edit"
}